import { catchError, filter, switchMap } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { AssetModel } from '@/models';
import { CreateComponentAssetPayload } from '@/store/slices/payload-types/asset-payload-types';

export const createComponentAssetEpic: PayloadEpic<CreateComponentAssetPayload, AssetModel> = (action$) => {
    return action$.pipe(
        filter(asyncActions.assets.createComponent.match),
        switchMap(({ payload }) =>
            concat(
                of(actions.assets.setIsCreating(true)),
                createComponent(payload).pipe(
                    switchMap(({ data, config }) => {
                        // After create, attach any selected nutrition files from create form (if any)
                        const payload = config?.data ? (JSON.parse(config.data as any) as CreateComponentAssetPayload) : undefined;
                        const selected = payload?.nutrition_file_uids || [];
                        if (selected.length > 0) {
                            axios
                                .post(`/mgmt/api/inventory/asset-nutrition-files/bulk-create/`, {
                                    asset: data.uid,
                                    items: selected.map((uid) => ({ nutrition_file: uid })),
                                })
                                .subscribe({ error: (e) => console.error('bulk-create nutrition files', e) });
                        }
                        return [actions.assets.addOne(data), actions.assets.setSavingErrors(null)];
                    }),
                    catchError((error) => {
                        console.error('createComponentAssetEpic', error?.response?.data);

                        return of(actions.assets.setSavingErrors(error?.response?.data || {}));
                    })
                ),
                of(actions.assets.setIsCreating(false))
            )
        )
    );
};

const createComponent = (payload: CreateComponentAssetPayload) => {
    return axios.post<AssetModel>(apiEndpoints.componentAssets(), payload);
};
